import React from "react";
import { PuffLoader } from "react-spinners";

function Loader() {
  return (
    <>
      <div
        style={{
          height: "100vh",
        //   display: "flex",
        //   justifyContent: "center",
        //   alignItems: "center",
        margin:"17% 50%",
        }}
      >
        <PuffLoader color="#634d8f" size={150} />
      </div>
    </>
  );
}

export default Loader;
